import { UserType } from "_interfaces";
import { atom } from "recoil";

const UserAtom = atom<UserType>({
  key: "User",
  default: JSON.parse(localStorage.getItem("user") as string) || false,
});

export { UserAtom };
